export default __webpack_public_path__ + "assets/pdf/iknowa Heat Pump Service Plan (EXAMPLE ONLY).fcd73ef2.pdf";